import {
	BaseTrackingSetup,
	DataWarehouseTracker,
	InstantConfigService,
	LabradorTracker,
} from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';

@Injectable()
export class UcpNoAdsTrackingSetup extends BaseTrackingSetup {
	constructor(
		protected labradorTracker: LabradorTracker,
		protected dwTracker: DataWarehouseTracker,
		protected instantConfig: InstantConfigService,
	) {
		super(labradorTracker, dwTracker, instantConfig);
	}

	execute(): void {
		super.execute();
	}
}
